/**
 * Use WebLock to prevent browser from going to sleep.
 * @see https://learn.microsoft.com/de-de/aspnet/core/signalr/javascript-client?view=aspnetcore-9.0&tabs=visual-studio#bsleep
 * @see https://developer.mozilla.org/de/docs/Web/API/Web_Locks_API
 */
export class WebLockHelper {

    private lockResolver: (res: unknown) => void;

    private createLock() {
        if (navigator && navigator.locks && navigator.locks.request) {
            const promise = new Promise((res) => {
                this.lockResolver = res;
            });

            navigator.locks.request('pcp_signalr_keep_active', { mode: "shared" }, () => promise);
        }
    }

    public lock() {
        this.createLock();
    }

    public release() {
        if (this.lockResolver) {
            this.lockResolver(null);
        }
    }
}
